var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CRow',[_c('CCol',{attrs:{"sm":"6","md":"4"}},[_c('CCard',[_c('CCardHeader',[_vm._v(" 订阅1 ")]),_c('CCardBody',[_c('CDataTable',{attrs:{"striped":"","small":"","fixed":"","items":_vm.visibleData,"fields":_vm.fields}})],1),_c('CCardFooter',[_c('CButton',{attrs:{"color":"primary"},on:{"click":_vm.goBack}},[_vm._v("Back")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }